(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pillow-ship-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    // MIRROR of tests/countdown-logic.mjs — keep these bodies in sync.
    function normalizeValue(value) {
      return String(value == null ? '' : value)
        .toLowerCase()
        .replace(/[“”″]/g, '"')
        .replace(/×/g, 'x')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function toList(value) {
      const result = [];
      String(value == null ? '' : value)
        .split(/[\n,]+/)
        .forEach((part) => {
          const trimmed = part.trim();
          if (trimmed) result.push(trimmed);
        });
      return result;
    }

    function matchesCombos(matchValues, options) {
      const present = (options || []).map((value) => normalizeValue(value));
      const groups = String(matchValues == null ? '' : matchValues)
        .split(/\n\s*\n/)
        .map((groupText) =>
          groupText
            .split('\n')
            .map((value) => normalizeValue(value))
            .filter(Boolean)
        )
        .filter((group) => group.length);
      if (!groups.length) return false;
      return groups.some((group) => group.every((value) => present.indexOf(value) !== -1));
    }

    function centralCalendarDate(now, timeZone) {
      const tz = timeZone || 'America/Chicago';
      const base = now instanceof Date ? now : new Date();
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).formatToParts(base);
      const get = (type) => Number(parts.find((p) => p.type === type).value);
      return new Date(get('year'), get('month') - 1, get('day'));
    }

    function countdownNumber(returnDate, startNumber, floorNumber, today) {
      if (!returnDate) return null;
      const parts = String(returnDate).split('-');
      if (parts.length !== 3) return null;

      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const day = parseInt(parts[2], 10);
      if (!year || !month || !day) return null;

      const target = new Date(year, month - 1, day);
      target.setHours(0, 0, 0, 0);
      if (isNaN(target.getTime())) return null;

      const t = today instanceof Date ? new Date(today.getTime()) : new Date();
      t.setHours(0, 0, 0, 0);

      const daysUntil = Math.round((target.getTime() - t.getTime()) / 86400000);
      if (daysUntil <= 0) return null;

      let floor = Number(floorNumber);
      if (!isFinite(floor)) floor = 3;

      let start = Number(startNumber);
      if (!isFinite(start)) start = floor;

      let number = floor + (daysUntil - 1);
      if (number > start) number = start;
      if (number < floor) return null;

      return number;
    }

    function countdownLowNumber(highNumber, startNumber, startNumberLow) {
      // Blank/missing low setting → single-number display. Check blank BEFORE Number():
      // Number(null) and Number('') are both 0, which isFinite() would accept as a value.
      if (startNumberLow == null || startNumberLow === '') return null;

      const low = Number(startNumberLow);
      const high = Number(startNumber);
      if (!isFinite(low) || !isFinite(high)) return null;

      // Preserve the configured gap as both numbers count down together.
      const gap = high - low;
      const result = highNumber - gap;
      return result < 1 ? 1 : result;
    }

    function isAllowedProduct(limitHandles, productHandle) {
      const handles = toList(limitHandles).map((handle) => handle.toLowerCase());
      if (!handles.length) return true;
      return handles.indexOf(String(productHandle || '').toLowerCase()) !== -1;
    }

    function selectTimeline(timelines, options) {
      const list = Array.isArray(timelines) ? timelines : [];
      for (let i = 0; i < list.length; i++) {
        const timeline = list[i];
        if (timeline && matchesCombos(timeline.matchValues, options)) return timeline;
      }
      return null;
    }

    function resolveText(config, options, today) {
      const evergreen = (config && config.evergreenText) || '';
      if (!config) return evergreen;

      if (!isAllowedProduct(config.limitHandles, config.productHandle)) return evergreen;

      const timeline = selectTimeline(config.timelines, options);
      if (!timeline) return evergreen;

      const number = countdownNumber(timeline.returnDate, timeline.startNumber, config.floorNumber, today);
      if (number === null) return evergreen;

      const low = countdownLowNumber(number, timeline.startNumber, timeline.startNumberLow);
      const display = low === null || low >= number ? String(number) : low + '-' + number;

      let text = String(config.countdownText || '').replace('{n}', display);
      if (display === '1') {
        text = text.replace(/\bdays\b/gi, (match) => (match.charAt(0) === 'D' ? 'Day' : 'day'));
      }
      return text;
    }

    // --- DOM wrapper ---
    class PillowShipCountdown extends HTMLElement {
      connectedCallback() {
        const configEl = this.querySelector('script[type="application/json"][data-psc-config]');
        this.textEl = this.querySelector('[data-psc-text]');
        if (!configEl || !this.textEl) return;

        try {
          this.config = JSON.parse(configEl.textContent);
        } catch (error) {
          return;
        }

        if (!this.config.enabled) return;

        this.onVariantUpdate = (event) => {
          const variant = event && event.detail ? event.detail.resource : null;
          if (!variant) return;
          this.render(variant.options || []);
        };

        this.scope = this.closest('.shopify-section, dialog') || document;
        this.scope.addEventListener('variant:update', this.onVariantUpdate);

        this.render(this.config.initialOptions || []);
      }

      disconnectedCallback() {
        if (this.scope && this.onVariantUpdate) {
          this.scope.removeEventListener('variant:update', this.onVariantUpdate);
        }
      }

      render(options) {
        const today = centralCalendarDate(new Date(), 'America/Chicago');
        const text = resolveText(this.config, options, today);
        if (this.textEl) this.textEl.textContent = text;
      }
    }

    if (!customElements.get('pillow-ship-countdown')) {
      customElements.define('pillow-ship-countdown', PillowShipCountdown);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
